module.exports = __webpack_public_path__ + "media/images/product/c2-fc97cf1544ee093952a9419d591a98b4.png";